module.exports = __webpack_public_path__ + "media/images/emoticons/downwardright-c7ae030ac5c2922202ebf8ecf321148a.gif";